const CURRENCY = {
    BTC: 'BTC',
    USD: 'USD',
};

export default CURRENCY;
